import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// ── Static imports: EN ──────────────────────────────────────
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enTickets from './locales/en/tickets.json';
import enDashboard from './locales/en/dashboard.json';
import enAdmin from './locales/en/admin.json';
import enProfile from './locales/en/profile.json';
import enHelp from './locales/en/help.json';
import enReporting from './locales/en/reporting.json';
import enLegal from './locales/en/legal.json';

// ── Static imports: FR ──────────────────────────────────────
import frCommon from './locales/fr/common.json';
import frAuth from './locales/fr/auth.json';
import frTickets from './locales/fr/tickets.json';
import frDashboard from './locales/fr/dashboard.json';
import frAdmin from './locales/fr/admin.json';
import frProfile from './locales/fr/profile.json';
import frHelp from './locales/fr/help.json';
import frReporting from './locales/fr/reporting.json';
import frLegal from './locales/fr/legal.json';

// ── Static imports: NL ──────────────────────────────────────
import nlCommon from './locales/nl/common.json';
import nlAuth from './locales/nl/auth.json';
import nlTickets from './locales/nl/tickets.json';
import nlDashboard from './locales/nl/dashboard.json';
import nlAdmin from './locales/nl/admin.json';
import nlProfile from './locales/nl/profile.json';
import nlHelp from './locales/nl/help.json';
import nlReporting from './locales/nl/reporting.json';
import nlLegal from './locales/nl/legal.json';

// ── Resources ───────────────────────────────────────────────

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    tickets: enTickets,
    dashboard: enDashboard,
    admin: enAdmin,
    profile: enProfile,
    help: enHelp,
    reporting: enReporting,
    legal: enLegal,
  },
  fr: {
    common: frCommon,
    auth: frAuth,
    tickets: frTickets,
    dashboard: frDashboard,
    admin: frAdmin,
    profile: frProfile,
    help: frHelp,
    reporting: frReporting,
    legal: frLegal,
  },
  nl: {
    common: nlCommon,
    auth: nlAuth,
    tickets: nlTickets,
    dashboard: nlDashboard,
    admin: nlAdmin,
    profile: nlProfile,
    help: nlHelp,
    reporting: nlReporting,
    legal: nlLegal,
  },
};

// ── Init ────────────────────────────────────────────────────

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth', 'tickets', 'dashboard', 'admin', 'profile', 'help', 'reporting', 'legal'],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'uniticket-language',
      caches: ['localStorage'],
    },
    react: {
      useSuspense: true,
    },
  });

// Sync <html lang="..."> on language change
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

// Set initial lang attribute
document.documentElement.lang = i18n.language;

export default i18n;
